export class Room {
  refId: string;
  placeId: number;
  roomType: RoomType | null;
  name: string;
  summary: string;
  description: string;
  doorNumber: string;
  pmsNumber: string;
  status: string;
  data: any;
  isActive: boolean;
  devices?: Device[] | null;

  constructor(dto: any) {
    this.refId = dto.ref_id;
    this.placeId = dto.place_id;
    this.roomType = dto.room_type ? new RoomType(dto.room_type) : null;
    this.name = dto.name;
    this.summary = dto.summary;
    this.description = dto.description;
    this.doorNumber = dto.door_number;
    this.pmsNumber = dto.pms_number;
    this.status = dto.status;
    this.data = dto.data;
    this.isActive = dto.is_active;
  }
}

import { RoomType } from "@shared/models/rooms/room-type.model";
import { Device } from "./device.model";

